import * as React from 'react';
import cn from 'classnames';
import { Modal } from '../../components/modal/Modal';
import { NumericInput } from '../../components/forms/Input';
import styles from './work-item-details.module.css';

export interface AirlineSnoozerProps {
  airlineCode: string;
  onSnooze: (airlineCode: string, hoursToSnooze: number) => void;
  showModal: boolean;
};

interface State {
  showModal: boolean;
  hoursToSnooze: number;
  iconHover: boolean;
};

const defaultHoursToSnooze = 24;

class AirlineSnoozer extends React.Component<AirlineSnoozerProps, State> {
  state: State = {
    showModal: this.props.showModal,
    hoursToSnooze: defaultHoursToSnooze,
    iconHover: false,
  };

  static defaultProps = {
    showModal: false,
  };

  showModal = () => this.setState({ showModal: true });

  hideModal = () => this.setState({ showModal: false });

  setIconHover = () => this.setState({ iconHover: true });

  clearIconHover = () => this.setState({ iconHover: false });

  updateInput = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const hoursToSnooze = e.currentTarget.value
      ? parseInt(e.currentTarget.value)
      : undefined;
    this.setState({ hoursToSnooze: hoursToSnooze || defaultHoursToSnooze });
  };

  onSubmit = () => {
    this.props.onSnooze(this.props.airlineCode, this.state.hoursToSnooze);
    this.hideModal();
  };

  render() {
    return (
      <>
        <div
          title="Snooze notifications"
          onClick={this.showModal}
          onMouseEnter={this.setIconHover}
          onMouseLeave={this.clearIconHover}
          className={cn(
            styles.airlineSnoozeIcon,
            'sprites',
            this.state.iconHover
              ? 'sprite-defer-selected-16'
              : 'sprite-defer-normal-16',
          )}
        />
        <Modal
          isOpen={this.state.showModal}
          onOpen={() => this.setState({ hoursToSnooze: defaultHoursToSnooze })}
          onClose={this.hideModal}
          onSubmit={this.onSubmit}
          title={`Snooze New Airline Notifications for ${this.props.airlineCode}`}
        >
          <div className={cn('row', styles.airlineSnoozeModalContent)}>
            <div className={cn('col-sm-4', styles.airlineSnoozeModalLabel)}>
              Hours to Snooze
            </div>
            <div className={cn('col-sm-4')}>
              <NumericInput
                name="hoursToSnooze"
                value={this.state.hoursToSnooze}
                onChange={this.updateInput}
              />
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default AirlineSnoozer;
